class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector("form");
    facetForm.addEventListener(
      "input",
      function (e) {
        // Check if the event target is not the facetSearch input
        if (!e.target.classList.contains("facetSearch")) {
          this.debouncedOnSubmit(e);
        } else {
          const showMoreButton = e.target
            .closest("details")
            .querySelectorAll("show-more-button button");
          if (showMoreButton.length > 0) {
            showMoreButton[0].click();
          }
          const searchTerm = e.target.value.toLowerCase();
          const listItems = e.target
            .closest("details")
            .querySelectorAll("ul li");
          listItems.forEach(function (li) {
            const itemText = li
              .querySelector("label .facet-checkbox__text-label")
              .textContent.toLowerCase();
            if (itemText.includes(searchTerm)) {
              li.style.display = ""; // Show the item
            } else {
              li.style.display = "none"; // Hide the item
            }
          });
        }
      }.bind(this)
    );
    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    console.log("trigger1");
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById(
      "ProductCountDesktop"
    );
    const loadingSpinners = document.querySelectorAll(
      ".facets-container .loading__spinner, facet-filters-form .loading__spinner"
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove("hidden"));
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");
    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    console.log("trigger2");
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === "function")
          initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    console.log("trigger3");
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === "function")
      initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    console.log("trigger4");
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;

    document
      .getElementById("ProductGridContainer")
      .querySelectorAll(".scroll-trigger")
      .forEach((element) => {
        element.classList.add("scroll-trigger--cancel");
      });
  }

  static renderProductCount(html) {
    console.log("trigger5");
    const count = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCount").innerHTML;
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    container.innerHTML = count;
    container.classList.remove("loading");
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
    const loadingSpinners = document.querySelectorAll(
      ".facets-container .loading__spinner, facet-filters-form .loading__spinner"
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add("hidden"));
  }

  static renderFilters(html, event) {
    console.log("trigger6");
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (
        !Array.from(facetDetailsElementsFromFetch).some(
          ({ id }) => currentElement.id === id
        )
      ) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter(
      (element) => !matchesId(element)
    );
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(
      matchesId
    );

    facetsToRender.forEach((elementToRender, index) => {
      console.log("trigger7");
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML =
          elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } =
            facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document
            .querySelector(`#${elementToRender.parentElement.id} .js-filter`)
            .before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest(".js-filter").id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(
          countsToRender,
          event.target.closest(".js-filter")
        );
        FacetFiltersForm.renderMobileCounts(
          countsToRender,
          document.getElementById(closestJSFilterID)
        );

        const newFacetDetailsElement =
          document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains(
          "mobile-facets__details"
        )
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate =
          newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute("type") === "text";

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
    $(".facets__disclosure-vertical.js-filter summary span").each(function (
      index,
      element
    ) {
      let value = $(element).text().trim();
      if (value === "Duration") {
        var ulElement = $(element)
          .closest("summary")
          .parent("details")
          .find("ul");
        var ulParent = ulElement.parent();

        // Hide the ul element
        // ulElement.show();

        // HTML for the range slider and labels
        var rangeSlider = `
            <div class="outerrainge">
                <div id="slider-range"></div>
                <div class="slider-labels">
                    <div class="caption">
                        <h5 id="min-label"></h5>
                    </div>
                    <div class="text-right caption">
                        <h5 id="max-label"></h5>
                    </div>
                </div>
            </div>
        `;

        ulParent.append(rangeSlider);
        var valueArrayChecked = [];
        var completeValueArray = [];

        // Loop through each list item (li) and process only checked checkboxes
        ulElement.find("li").each(function () {
          var checkbox = $(this).find('input[type="checkbox"]');
           var label = $(this)
              .find(".facet-checkbox__text-label")
              .text()
              .trim();
            var value = parseFloat(label); // Convert the label text to a float value
            completeValueArray.push(value); // Push the checked value into the array
          
          var checkedCheckbox = checkbox.prop("checked"); // Check if the checkbox is checked
          if (checkedCheckbox) {
            // Only process if the checkbox is checked
            var label = $(this)
              .find(".facet-checkbox__text-label")
              .text()
              .trim();
            var value = parseFloat(label); // Convert the label text to a float value
            valueArrayChecked.push(value); // Push the checked value into the array
          }
        });

        // Initialize the slider with min and max values
     
        // Find the smallest and largest checked values from the array
        var smallestValueChecked = valueArrayChecked.length > 0 ? Math.min(...valueArrayChecked) : 2;
        var largestValueChecked = valueArrayChecked.length > 0 ? Math.max(...valueArrayChecked) : 5;

         // Find the smallest and largest values from the duration metafield value
        var smallestDurationValue = completeValueArray.length > 0 ? Math.min(...completeValueArray) : 2;
        var largestDurationValue = completeValueArray.length > 0 ? Math.max(...completeValueArray) : 5;

        var step = 0.01; // Define the step for decimal increments

        var minCheckedValue = Math.floor(smallestValueChecked); // Round down for minValue
        var maxCheckedValue = Math.ceil(largestValueChecked); // Round up for maxValue

        var minDurationValue = Math.floor(smallestDurationValue); // Round down for minValue
        $('#min-label').html(minCheckedValue + " Hours"); //Appending the minimum value to label
        var maxDurationValue = Math.ceil(largestDurationValue); // Round up for maxValue
        $('#max-label').html(maxCheckedValue + " Hours"); //Appending the maximum value to label

        
        $("#slider-range").slider({
          range: true,
          min: minDurationValue,
          max: maxDurationValue,
          values: [minCheckedValue, maxCheckedValue],
          slide: function (event, ui) {            
            $("#min-label").text(ui.values[0] + " hours");
            $("#max-label").text(ui.values[1] + " hours");
          },
          change: function (event, ui) {
            triggerCheckboxClicks(ui.values[0], ui.values[1], step);
          },
        });

       
        // function getLeftPercentage(value) {
        //   switch (value) {
        //     case 2:
        //       return "0%";
        //     case 3:
        //       return "25%";
        //     case 4:
        //       return "50%";
        //     case 5:
        //       return "75%";
        //     default:
        //       return "0%"; // Default value if none match
        //   }
        // }

        // function calculateWidth(min, max) {
        //   // Calculate width based on min and max values
        //   if (min == 2) {
        //     switch (max) {
        //       case 3:
        //         return "25%";
        //       case 4:
        //         return "50%";
        //       case 5:
        //         return "75%";
        //       case 6:
        //         return "100%";
        //     }
        //   } else if (min == 3) {
        //     switch (max) {
        //       case 4:
        //         return "25%";
        //       case 5:
        //         return "50%";
        //       case 6:
        //         return "75%";
        //     }
        //   } else if (min == 4) {
        //     switch (max) {
        //       case 5:
        //         return "25%";
        //       case 6:
        //         return "50%";
        //     }
        //   }
        //   return "0%"; // Default value if none match
        // }
        
        // $(".ui-slider-handle").map((index, ui) => {
        //   // Round the values if they contain decimals
        //   let totalLengthDurationArray = maxDurationValue - minDurationValue;
        //   let value = index == 0 ? minCheckedValue : maxCheckedValue; // Determine if it's min or max based on the index
        //   $(ui).css("left", getLeftPercentage(value)); // Apply the left value
        //   if(index == 0){
        //     $('.ui-widget-header').css("left", getLeftPercentage(value));
        //   }
        // });


        // Apply the calculated width to the ui-widget-header class
        // $(".ui-widget-header").css("width", calculateWidth(minCheckedValue, maxCheckedValue));

        function triggerCheckboxClicks(min, max, step) {
          console.log("triggerCheckbox", step);
          // Generate values within the range with the specified step
          var valuesInRange = [];
          for (var i = min; i <= max; i += step) {
            valuesInRange.push(parseFloat(i.toFixed(2))); // Ensure only two decimal places
          }

          // Compare generated values with the labels and trigger click if needed
          ulElement.find("li").each(function () {
            var checkbox = $(this).find('input[type="checkbox"]');
            var label = $(this)
              .find(".facet-checkbox__text-label")
              .text()
              .trim();
            var value = parseFloat(label);

            if (valuesInRange.includes(value)) {
              if (!checkbox.is(":checked")) {
                checkbox.click(); // Simulate click
              }
            } else {
              if (checkbox.is(":checked")) {
                checkbox.click(); // Simulate click
              }
            }
          });
        }
        // }
      }
    });
  }

  static renderActiveFacets(html) {
    console.log("trigger8");
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    console.log("trigger9");
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });

    document
      .getElementById("FacetFiltersFormMobile")
      .closest("menu-drawer")
      .bindEvents();
  }

  static renderCounts(source, target) {
    console.log("trigger10");
    const targetSummary = target.querySelector(".facets__summary");
    const sourceSummary = source.querySelector(".facets__summary");

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector(".facets__header");
    const sourceHeaderElement = source.querySelector(".facets__header");

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector(".facets-wrap");
    const sourceWrapElement = source.querySelector(".facets-wrap");

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(
        target.querySelector("show-more-button .label-show-more.hidden")
      );
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll(".facets__item.hidden")
          .forEach((hiddenItem) =>
            hiddenItem.classList.replace("hidden", "show-more-item")
          );
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector(".mobile-facets__list");
    const sourceFacetsList = source.querySelector(".mobile-facets__list");

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    console.log("trigger11");
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    console.log("trigger12");
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll(
      "facet-filters-form form"
    );
    if (event.srcElement.className == "mobile-facets__checkbox") {
      const searchParams = this.createSearchParams(
        event.target.closest("form")
      );
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile =
        event.target.closest("form").id === "FacetFiltersFormMobile";

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (
            form.id === "FacetSortForm" ||
            form.id === "FacetFiltersForm" ||
            form.id === "FacetSortDrawerForm"
          ) {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === "FacetFiltersFormMobile") {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join("&"), event);
    }
  }

  onActiveFilterClick(event) {
    console.log("trigger13");
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1
          );
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) => {
      element.addEventListener("change", this.onRangeChange.bind(this));
      element.addEventListener("keydown", this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern =
      /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("data-max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("data-min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("data-min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("data-max", maxInput.getAttribute("data-max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("data-min"));
    const max = Number(input.getAttribute("data-max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");
    form.onActiveFilterClick(event);
  }
}

customElements.define("facet-remove", FacetRemove);




// custom js 08/01/25

 let lastURL = window.location.href;  // To store the initial URL
    let reloadDone = false;  // A flag to track if the page has already reloaded

    // Function to add a new query parameter to the URL
    function addValueToURL() {
      // You can add any value to the URL here
      const newURL = window.location.href.split('?')[0] + '?newValue=' + Date.now();
      window.history.pushState({path: newURL}, '', newURL);  // This updates the URL without refreshing the page
    }

    // Function to check if the URL has changed and reload the page once
    function checkURLChange() {
      if (window.location.href !== lastURL && !reloadDone) {
        console.log("URL changed, reloading the page...");
        reloadDone = true;  // Set the flag to true to prevent further reloads
        location.reload();  // Reload the page once when the URL changes
      }
    }

    // Set interval to check for URL changes every second
    setInterval(checkURLChange, 1000);